import {Component, EventEmitter, Input, OnInit, Output, ViewChild} from "@angular/core";
import {InputSelectComponent} from "../input-select/input-select.component";
import {FinService} from "../../../models/FinService/fin-service";
import {toastrService} from "../../../services/ux/toastr.service";

@Component({
    selector: "app-chips-search",
    templateUrl: "./chips-search.component.html",
    styleUrls: ["./chips-search.component.css"]
})
export class ChipsSearchComponent {
    private _suggestionsArray = [] as FinService[];

    get suggestionsArray(): FinService[] {
        return this._suggestionsArray;
    }

    @Input()
    set suggestionsArray(value: FinService[]) {
        this._suggestionsArray = value;
        if (value.length) {
            this.suggestionArrayOfNames = value.map(x => x.code).filter(x => x.toLowerCase() !== "te gjitha");
        }
    }

    suggestionArrayOfNames = [] as string[];

    chipsArray = [];

    @ViewChild(InputSelectComponent) appElement: InputSelectComponent;

    @Output() chipChange = new EventEmitter<{
        action: string,
        chipName: string
    }>();

    constructor(private toast: toastrService) {
    }

    removeChipFromArray(chipName: string): void {
        const index = this.chipsArray.indexOf(chipName);
        this.chipsArray.splice(index, 1);
        this.chipChange.emit({chipName, action: "-"});
    }

    addChipToArray(chipName: string): void {
        // * Prevent double entry
        if (this.chipsArray.indexOf(chipName) === -1) {
            this.chipsArray.push(chipName);
            this.chipChange.emit({chipName, action: "+"});
            return;
        }

        this.toast.warning("Ky filter ekziston!");
    }

    onBackdrop(): void {
        console.log("Backdrop Clicked");
        this.appElement.onBlur();
    }
}
